export default __webpack_public_path__ + "static/media/kisan_agro_industries-project-10.3409ae0e.png";